import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import {
	AccessStatus,
	ConfluenceEdition,
} from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { PremiumTrialEotQuery } from './PremiumTrialEotQuery.ts';

export function preloadPremiumTrialEotQuery(): Promise<void | any[] | Error[]> {
	const { accessStatus, activationId, cloudId, edition, isLoggedIn, userId } =
		getPreloaderFnContext();
	const queries: Promise<any>[] = [];

	if (
		isLoggedIn &&
		Boolean(activationId) &&
		Boolean(userId) &&
		Boolean(cloudId) &&
		edition === ConfluenceEdition.PREMIUM &&
		(accessStatus == AccessStatus.LICENSED_USE_ACCESS ||
			accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS)
	) {
		queries.push(
			queryAgg({
				query: PremiumTrialEotQuery,
				variables: {
					cloudId,
				},
			}),
		);
	}

	return waitForAllReturnWhenError(queries);
}
